import {Component, HostListener, Input, OnInit} from '@angular/core';
import {clientRoles} from "../../user/user-roles-actions";
import {
  UserSubscription,
  UserSubscriptionCategory,
  UserSubscriptionIds,
  UserSubscriptionType
} from "../../user/user-subscription";
import {DbModalService} from "../../modules/modal/modal";
import {CreateWebsiteService} from "../../services/local/create-website.service";
import {DialogService} from "../../../ng2-bootstrap-modal/dialog.service";
import {PaymentDialogComponent} from "../../workspace/billing/payment-dialog/payment-dialog.component";
import {UserSubscriptionStatus} from "../../user/user-subscription-status";
import {GoogleAnalyticsService} from "../../shared/services/google-analytics/google-analytics.service";
import {User} from "../../user/user";
import {Utils} from "../../shared/utils/utils";
import * as fromStore from '../../store';
import {Store} from '@ngrx/store';
import {ActivatedRoute} from "@angular/router";
import {
  DedicatedVmContactComponent
} from "../../components/common/dedicated-vm-contact-dialiog/dedicated-vm-contact.component";
import {TypeUtils} from "../../shared/utils/type-utils";
import {
  OneWeekFreeDemoUpgradeComponent
} from "../../shared/components/dialogs/one-month-free/components/one-week-free-demo-upgrade/one-week-free-demo-upgrade.component";
import {OneMonthFreeComponent} from "../../shared/components/dialogs/one-month-free/one-month-free.component";

@Component({
    selector: 'db-websites-controls',
    templateUrl: './websites-controls.component.html',
    styleUrls: ['./websites-controls.component.scss'],
    standalone: false
})
export class WebsitesControlsComponent implements OnInit {

  @Input() workspaceRole: number;
  @Input() userSubscription: UserSubscription;
  @Input() user: User;
  @Input() canBuyAdditionalWebsite: boolean = false;
  @Input() disableControls: boolean = false;
  @Input() websitesCount: number = 0;
  @Input() enabledCdnCount: number = 0;
  @Input() additionalWebsitesCount: number = 0;
  @Input() hostedAndSpeedWebsitesCount: number = 0;
  @Input() hostedWebsitesWithMultiCount: number = 0;
  @Input() hostingLimit: number = 0;
  @Input() hasHostingService: boolean = false;
  @Input() hasBoosterService: boolean = false;
  @Input() isUploading?: boolean = false;
  @Input() percent?: number = 0;
  @Input() hasOngoingMigrationActivity?: boolean = false;
  @Input() ongoingMigrationActivity?: any;
  @Input() userLocalStorage: any;
  @Input() hostedWebsitesCount: any;

  public UserSubscriptionCategory: any = UserSubscriptionCategory;
  public readonly clientRoles = clientRoles;
  public readonly userSubscriptionIds = UserSubscriptionIds;
  public readonly userSubscriptionType = UserSubscriptionType;
  public userSubscriptionStatus: any = UserSubscriptionStatus;
  public readonly userSubscriptionCategory = UserSubscriptionCategory;
  public UserSubscriptionType = UserSubscriptionType;


  public additionalWebsitePrice: number = 0;
  public demoUser: boolean = false;
  showZoneIssue: boolean = false;
  public toggled: boolean = false;
  private _canCreate = false;
  public disableWebsiteActions: boolean = false;
  protected readonly UserSubscriptionStatus = UserSubscriptionStatus;

  constructor(
    private readonly _modalService: DbModalService,
    private readonly _createWebsiteService: CreateWebsiteService,
    private readonly _dialogService: DialogService,
    private _googleAnalyticsService: GoogleAnalyticsService,
    private _store: Store<fromStore.DbStoreState>,
    private _route: ActivatedRoute
  ) {
  }

  ngOnInit() {
    this.demoUser = Utils.isDemoUser(this.userSubscription, this.user);
    this.userSubscription?.isDedicatedVM && (this.showZoneIssue = true);
    this.additionalWebsitePrice = this.userSubscription && this.userSubscription.plan && this._calculateAdditionalWebsitePrice(this.userSubscription.boosterProClient ? this.userSubscription.plan.additionalCDNParameterPrice : this.userSubscription.plan.additionalDomainParameterPrice);
    !this.disableControls && this._migrateZip();
    this._canCreate = this.userSubscription.domainsPermission && this.userSubscription.domainsPermission.canCreateWebsite;
    if (this.userSubscription.status === UserSubscriptionStatus?.canceled && (!this._canCreate || (this.userSubscription && this.userSubscription.boosterProClient
      && (this.hostedWebsitesCount === this.userSubscription?.plan?.additionalDomainCount)))) {
      this.disableControls = true;
    }
  }

  private _migrateZip(): void {
    const queryParams: any = (<any>this._route.queryParams).value;
    const migrateWithZip = queryParams.migrate_zip || new URL(window.location.href).searchParams.get("migrate_zip");
    if (migrateWithZip) {
      this.openMigrateWebsiteModal(true);
    }
  }

  public openCreateWebsiteModal(label): void {
    if (!this.userLocalStorage['hasCreatedInstance'] && this.userSubscription?.isDedicatedVM) {
      const modal = this._modalService.open(DedicatedVmContactComponent, {height: 230, width: 500});
      modal.componentInstance.zoneIssue = true;
      return;
    }
    if (this.demoUser) {
      this._openCheckoutDialog(label);
    } else {
      this._createWebsiteService.openCreateWebsiteModal(this.userSubscription && this.userSubscription.boosterProClient, label);
    }
  }

  public openMigrateWebsiteModal(label, manualMigrate: boolean = false): void {
    if (this.userLocalStorage && !this.userLocalStorage['hasCreatedInstance'] && this.userSubscription?.isDedicatedVM) {
      const modal = this._modalService.open(DedicatedVmContactComponent, {height: 230, width: 500});
      modal.componentInstance.zoneIssue = true;
      return;
    }
    if (this.demoUser) {
      this._openCheckoutDialog(label);
    } else {
      this._createWebsiteService.openDownloadManagerMigrateModal(this.userSubscription && this.userSubscription.boosterProClient, manualMigrate, label);
    }
  }

  private _openCheckoutDialog(label) {
    const analyticsData = {
      eventCategory: 'Free Upgrade Offer',
      eventAction: 'Locked button click',
      eventLabel: label
    };
    if (this.demoUser) {
      const firstTime = TypeUtils.isNull(localStorage.getItem('dbShowFirstTime'));
      const options = {
        overflowHidden: false,
        backdropClass: 'blurred',
      };
      if (!firstTime) {
        options['width'] = 1240;
      } else {
        options['width'] = 460;
        options['height'] = 600;
      }
      const modal = this._modalService.open(OneWeekFreeDemoUpgradeComponent, options);
      modal.componentInstance.showFirstTime = firstTime;
    } else {
      const modal = this._modalService.open(OneMonthFreeComponent, {height: 600, width: 940});
      modal.componentInstance.mode = 'feature';
    }
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
    return false;
  }

  public openOptimizeModal(): void {
    if (this.demoUser) {
      this._openCheckoutDialog('Dashboard: Websites list: Optimize button');
    } else {
      this._createWebsiteService.openOptimizeModal();
    }
  }

  public openDownloadManagerRecreateModal(): void {
    this._createWebsiteService.openDownloadManagerRecreateModal();
  }

  public openDownloadManagerConnectModal(): void {
    this._createWebsiteService.openDownloadManagerConnectModal();
  }

  private _calculateAdditionalWebsitePrice(additionalParamPrice): number {
    if (!this.userSubscription
      || !this.userSubscription.plan
      || !additionalParamPrice) {
      return 0;
    }
    let price = this.userSubscription.plan.periodNumber === 12 ? additionalParamPrice / 12
      : additionalParamPrice;
    if (price % 1 !== 0) {
      price = Number(price.toFixed(2));
    }
    return price;
  }

  public buyNow(): void {
    this._store.dispatch(new fromStore.LoadUserPaymentMethods());
    this._dialogService
      .addDialog(PaymentDialogComponent, {
        upgradeSubscription: this.userSubscription,
        fromDialog: false,
        showAdditional: true,
        buyCdnAddOn: this.userSubscription.boosterProClient
      });
  }

  @HostListener('document:click', ['$event'])
  onClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.classList.contains('actions-dropdown')
      && !target.parentElement?.classList.contains('actions-dropdown')) {
      this.toggled = false;
    }
  }

}
